import { BaseAPIError } from './BaseAPIError'

export class NotAccessibleAPIError extends BaseAPIError {}
